angular.module('bmsApp.audit').factory('AuditLogSvc', function (CRUDSvc) {

	var self = {
		getAuditLog: function (params) {
			return CRUDSvc.get('api/audit/audit-log', params);
		},
		getEventNameOptions: function () {
			return CRUDSvc.get('api/audit/event-name-options');
		}
	};
	return self;

});
